import axios from 'axios'
import { config, configMultipart, url } from '../../index'
import { clearUserHtml, currentDateTime } from '@/utils/utils'
import { createItem } from '@/api/defaultApi'
import getValuesArray from '@/utils/array/getValuesArray'

const state = () => ({
  /* примеры объектов задач */
  tasks: [],
  taskBoard: {
    // переменная нужна для хранения перетаскиваемой карточки
    pickedCard: null,
    // createColumn будет добавляться при
    createColumn: {
      active: false,
      title: '',
      colorPicker: {
        active: false,
        color: 'blue'
      }
    },
    columns: []
  },
  tableHeaders: [
    {
      title: 'Название',
      isSortable: false
    },
    {
      title: 'Дата создания',
      isSortable: false
    },
    {
      title: 'Статус',
      isSortable: false
    },
    {
      title: 'Крайний срок',
      isSortable: false
    },
    {
      title: 'Подзадачи',
      isSortable: false
    },
    {
      title: 'Постановщик',
      isSortable: false
    },
    {
      title: 'Ответственные',
      isSortable: false
    }
  ],
  viewSwitcher: {
    list: true,
    board: false
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {
    date: {
      created_active: false,
      created_from: '',
      created_to: '',
      finish_active: false,
      finish_from: '',
      finish_to: ''
    },
    list: {
      active: false,
      data: '',
      current: 'Все задачи',
      clear: 'Все задачи',
      inProgress: 'Делаю',
      created: 'Поручил',
      watch: 'Наблюдаю'
    },
    column: { id: 0, name: 'Все задачи' },
    assignee: { id: 0, name: 'Не выбран' }
  },
  createModal: {
    active: false,
    isLoading: false,
    validation: {
      name: {},
      description: {},
      assignees: {}
    },
    name: '',
    description: '',
    is_important: false,
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: []
    },
    date_deadline: currentDateTime(),
    parentTask: { id: null, name: '' },
    column: { id: 1, name: 'Ждет выполнения' },
    assignees: [],
    watchers: []
  },
  isLoading: true
})

const getters = {
  getTaskList: state => state.tasks,
  taskListTaskBoard: state => state.taskBoard,
  taskListTableHeaders: state => state.tableHeaders,
  taskListViewSwitcher: state => state.viewSwitcher,
  taskListPagination: state => state.pagination,
  taskListSearchValue: state => state.searchValue,
  taskListFilter: state => state.filter,
  taskListCreateModal: state => state.createModal,
  taskListIsLoading: state => state.isLoading
}

const mutations = {
  GET_TASKS: (state, tasks) => {
    state.tasks = tasks.map((task) => {
      return {
        ...task,
        isControlsActive: false
      }
    })
    state.isLoading = false
  },
  GET_TASK_COLUMNS: (state, columns) => {
    state.taskBoard.columns = columns.map((column) => {
      return {
        ...column,
        tasks: column.tasks ? [...column.tasks].sort((taskA, taskB) => {
          if (taskA.sort_order < taskB.sort_order) {
            return -1
          }
          if (taskA.sort_order > taskB.sort_order) {
            return 1
          }
          return 0
        }) : [],
        isControlsActive: false
      }
    })
  },
  SET_TASK_LIST_IS_LOADING: (state) => {
    state.isLoading = true
  },
  TOGGLE_TASK_LIST_TABLE_ITEM_CONTROLS: (state, itemId) => {
    state.tasks.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  CLOSE_TASK_LIST_ITEMS_CONTROLS: (state) => {
    state.tasks.forEach((elem) => {
      elem.isControlsActive = false
    })
  },

  // create modal
  SHOW_TASK_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  '[task-list-page] MODAL_REQUEST_START': state => {
    state.createModal.isLoading = true
  },
  '[task-list-page] MODAL_REQUEST_SUCCESS': state => {
    state.createModal.isLoading = false
  },
  '[task-list-page] MODAL_REQUEST_FAILURE': state => {
    state.createModal.isLoading = false
  },
  CLOSE_TASK_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = false
  },
  CLEAR_TASK_LIST_MODAL: (state) => {
    state.createModal.name = ''
    state.createModal.description = ''
    state.createModal.is_important = false
    state.createModal.date_deadline = currentDateTime()
    state.createModal.parentTask = { id: null, name: '' }
    state.createModal.column = { id: 1, name: 'Ждет выполнения' }
    state.createModal.assignees = []
    state.createModal.watchers = []
    state.createModal.attachment.files = []
    state.createModal.attachment.tags = []
  },
  SET_TASK_LIST_NEW_TASK_NAME: (state, text) => {
    state.createModal.name = text
  },
  TOGGLE_TASK_LIST_NEW_TASK_IMPORTANCE: (state) => {
    state.createModal.is_important = !state.createModal.is_important
  },
  SET_TASK_LIST_NEW_TASK_DESCRIPTION: (state, text) => {
    state.createModal.description = text
  },
  SET_TASK_LIST_NEW_TASK_DEADLINE: (state, date) => {
    state.createModal.date_deadline = date
  },
  SET_TASK_LIST_NEW_TASK_PARENT_TASK: (state, task) => {
    state.createModal.parentTask = task
  },
  SET_TASK_LIST_NEW_TASK_COLUMN: (state, column) => {
    state.createModal.column = column
  },
  ADD_TASK_LIST_NEW_TASK_ASSIGNEE: (state, user) => {
    state.createModal.assignees.push(user)
  },
  REMOVE_TASK_LIST_NEW_TASK_ASSIGNEE: (state, user) => {
    state.createModal.assignees = state.createModal.assignees.filter(assignee => {
      return assignee.id !== user.id
    })
  },
  ADD_TASK_LIST_NEW_TASK_WATCHER: (state, user) => {
    state.createModal.watchers.push(user)
  },
  REMOVE_TASK_LIST_NEW_TASK_WATCHER: (state, user) => {
    state.createModal.watchers = state.createModal.watchers.filter(watcher => {
      return watcher.id !== user.id
    })
  },
  TOGGLE_TASK_LIST_MODAL_LINK_TOOLTIP: (state) => {
    state.createModal.attachment.linkTooltip.active = !state.createModal.attachment.linkTooltip.active
  },
  CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP: (state) => {
    state.createModal.attachment.linkTooltip.textValid = {}
    state.createModal.attachment.linkTooltip.urlValid = {}
    state.createModal.attachment.linkTooltip.text = ''
    state.createModal.attachment.linkTooltip.url = ''
    state.createModal.attachment.linkTooltip.active = false
  },
  SET_TASK_LIST_MODAL_LINK_TEXT: (state, text) => {
    state.createModal.attachment.linkTooltip.text = text
  },
  SET_TASK_LIST_MODAL_LINK_URL: (state, url) => {
    state.createModal.attachment.linkTooltip.url = url
  },
  TOGGLE_TASK_LIST_MODAL_TAG_TOOLTIP: (state) => {
    state.createModal.attachment.tagTooltip.active = !state.createModal.attachment.tagTooltip.active
  },
  CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP: (state) => {
    state.createModal.attachment.tagTooltip.textValid = {}
    state.createModal.attachment.tagTooltip.urlValid = {}
    state.createModal.attachment.tagTooltip.text = ''
    state.createModal.attachment.tagTooltip.url = ''
    state.createModal.attachment.tagTooltip.active = false
  },
  SET_TASK_LIST_MODAL_TAG_TEXT: (state, text) => {
    state.createModal.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  ATTACH_TASK_LIST_MODAL_FILES: (state, files) => {
    const newFiles = Object.values(files)
    state.createModal.attachment.files = state.createModal.attachment.files.concat(newFiles)
  },
  REMOVE_TASK_LIST_MODAL_FILE: (state, data) => {
    // по index вырезаем файл из массива отображаемых вложений
    const files = state.createModal.attachment.files
    files.splice(data.index, 1)
    state.createModal.attachment.files = files
  },
  ATTACH_TASK_LIST_MODAL_TAG: (state) => {
    const tagText = state.createModal.attachment.tagTooltip.text
    state.createModal.attachment.tags.push(tagText)
  },
  REMOVE_TASK_LIST_MODAL_TAG: (state, index) => {
    const tags = [...state.createModal.attachment.tags]
    tags.splice(index, 1)
    state.createModal.attachment.tags = tags
  },
  SET_TASK_LIST_MODAL_LINK_TEXT_VALID: (state, valid) => {
    state.createModal.attachment.linkTooltip.textValid = valid
  },
  SET_TASK_LIST_MODAL_LINK_URL_VALID: (state, valid) => {
    state.createModal.attachment.linkTooltip.urlValid = valid
  },
  SET_TASK_LIST_MODAL_TAG_VALID: (state, valid) => {
    state.createModal.attachment.tagTooltip.valid = valid
  },
  SET_TASK_LIST_CREATE_MODAL_VALIDATION: (state, valid) => {
    state.createModal.validation.name = valid.name !== undefined ? { type: 'error', message: valid.name[0] } : {}
    state.createModal.validation.description = valid.description !== undefined ? { type: 'error', message: valid.description[0] } : {}
    state.createModal.validation.assignees = valid.assignees !== undefined ? { type: 'error', message: valid.assignees[0] } : {}
  },
  CLEAR_TASK_LIST_MODAL_VALID: (state) => {
    state.createModal.validation.name = {}
    state.createModal.validation.description = {}
    state.createModal.validation.assignees = {}
    state.createModal.attachment.linkTooltip.textValid = {}
    state.createModal.attachment.linkTooltip.urlValid = {}
    state.createModal.attachment.tagTooltip.valid = {}
  },

  // task-board
  SHOW_TASK_BOARD_NEW_COLUMN_FORM: (state) => {
    state.taskBoard.createColumn.active = true
  },
  CLOSE_TASK_BOARD_NEW_COLUMN_FORM: (state) => {
    state.taskBoard.createColumn.active = false
  },
  TOGGLE_TASK_BOARD_COLOR_PICKER: (state) => {
    state.taskBoard.createColumn.colorPicker.active = !state.taskBoard.createColumn.colorPicker.active
  },
  CLOSE_TASK_BOARD_COLOR_PICKER: (state) => {
    state.taskBoard.createColumn.colorPicker.active = false
  },
  SET_TASK_BOARD_NEW_COLUMN_COLOR: (state, colorName) => {
    state.taskBoard.createColumn.colorPicker.color = colorName
  },
  SET_TASK_BOARD_NEW_COLUMN_TITLE: (state, title) => {
    state.taskBoard.createColumn.title = title
  },
  TOGGLE_TASK_BOARD_COLUMN_CONTROLS: (state, columnId) => {
    state.taskBoard.columns.forEach((elem) => {
      if (columnId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (columnId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  CLOSE_TASK_BOARD_COLUMN_CONTROLS: (state, columnId) => {
    state.taskBoard.columns.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  SORT_TASK_BOARD_COLUMNS: (state, dropResult) => {
    const removedIndex = dropResult.removedIndex
    const addedIndex = dropResult.addedIndex
    state.taskBoard.columns = arrayMove([...state.taskBoard.columns], removedIndex, addedIndex)

    function arrayMove (arr, oldIndex, newIndex) {
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
      return arr
    }
  },
  PICK_TASK_BOARD_CARD: (state, data) => {
    const columnId = data.columnId
    const removedIndex = data.cardIndex

    function removedCard (arr, index) {
      return [...arr].splice(index, 1)
    }

    // перемещение из колонки, вырезаем и храним в стейте
    state.taskBoard.pickedCard = removedCard(state.taskBoard.columns.find(column => column.id === columnId).tasks, removedIndex)[0]
  },
  DROP_TASK_BOARD_CARD: (state, data) => {
    const columnId = data.columnId
    const removedIndex = data.dropResult.removedIndex
    const addedIndex = data.dropResult.addedIndex

    function removeCard (arr, index) {
      arr.splice(index, 1)
    }

    function arrayMove (arr, oldIndex, newIndex) {
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0])
      return arr
    }

    if (removedIndex !== null && addedIndex !== null) {
      // перемещение внутри колонок
      const cardArray = state.taskBoard.columns.find(column => column.id === columnId).tasks
      state.taskBoard.columns.find(column => column.id === columnId).tasks = arrayMove([...cardArray], removedIndex, addedIndex)
    }

    if (addedIndex !== null && removedIndex === null) {
      // перемещение в колонку, берем из стейта и вставляем
      state.taskBoard.columns.find(column => column.id === columnId).tasks.splice(addedIndex, 0, state.taskBoard.pickedCard)
    }

    if (removedIndex !== null && addedIndex === null) {
      // вырезаем карточку их исходного массива
      removeCard(state.taskBoard.columns.find(column => column.id === columnId).tasks, removedIndex)
    }
  },

  // pagination
  SET_TASK_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  TOGGLE_TASK_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_TASK_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  },
  RESET_TASK_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },

  // search
  SET_TASK_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  TOGGLE_TASK_LIST_FILTER_DATE_CREATED: (state) => {
    state.filter.date.created_active = !state.filter.date.created_active
  },
  CLOSE_TASK_LIST_FILTER_DATE_CREATED: (state) => {
    state.filter.date.created_active = false
  },
  SET_TASK_LIST_FILTER_DATE_CREATED_FROM: (state, date) => {
    state.filter.date.created_from = date
  },
  SET_TASK_LIST_FILTER_DATE_CREATED_TO: (state, date) => {
    state.filter.date.created_to = date
  },
  CLEAR_TASK_LIST_FILTER_DATE_CREATED: (state) => {
    state.filter.date.created_from = ''
    state.filter.date.created_to = ''
  },
  TOGGLE_TASK_LIST_FILTER_DATE_FINISH: (state) => {
    state.filter.date.finish_active = !state.filter.date.finish_active
  },
  CLOSE_TASK_LIST_FILTER_DATE_FINISH: (state) => {
    state.filter.date.finish_active = false
  },
  SET_TASK_LIST_FILTER_DATE_FINISH_FROM: (state, date) => {
    state.filter.date.finish_from = date
  },
  SET_TASK_LIST_FILTER_DATE_FINISH_TO: (state, date) => {
    state.filter.date.finish_to = date
  },
  CLEAR_TASK_LIST_FILTER_DATE_FINISH: (state) => {
    state.filter.date.finish_from = ''
    state.filter.date.finish_to = ''
  },
  TOGGLE_TASK_LIST_FILTER_LIST: (state) => {
    state.filter.list.active = !state.filter.list.active
  },
  CLEAR_TASK_LIST_FILTER: (state) => {
    state.filter.list.current = state.filter.list.clear
    state.filter.list.data = ''
  },
  SET_TASK_LIST_FILTER: (state, filterData) => {
    switch (filterData.filter) {
      case 'inProgress':
        state.filter.list.current = state.filter.list.inProgress
        state.filter.list.data = `search[assign_id]=${filterData.currentUserId}&search[column]=2`
        break
      case 'created':
        state.filter.list.data = `search[owner_id]=${filterData.currentUserId}`
        state.filter.list.current = state.filter.list.created
        break
      case 'watch':
        state.filter.list.current = state.filter.list.watch
        state.filter.list.data = `search[watcher_id]=${filterData.currentUserId}`
        break
      default:
        break
    }
  },
  CLOSE_TASK_LIST_FILTER_LIST: (state) => {
    state.filter.list.active = false
  },
  SET_TASK_LIST_FILTER_COLUMN: (state, column) => {
    state.filter.column = column
  },
  SET_TASK_LIST_FILTER_ASSIGNEE: (state, user) => {
    state.filter.assignee = user
  },

  // view switcher
  SET_TASK_LIST_LIST_VIEW: (state) => {
    state.viewSwitcher.list = true
    state.viewSwitcher.board = false
  },
  SET_TASK_LIST_BOARD_VIEW: (state) => {
    state.viewSwitcher.list = false
    state.viewSwitcher.board = true
  }
}

const actions = {
  getTasks ({ commit, state }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const combinedFilter = state.filter.list.data
    const dateFilter = `${state.filter.date.created_from ? `search[created_from]=${state.filter.date.created_from}` : ''}&${state.filter.date.created_to ? `search[created_to]=${state.filter.date.created_to}` : ''}&${state.filter.date.finish_from ? `search[before_from]=${state.filter.date.finish_from}` : ''}&${state.filter.date.finish_to ? `search[before_to]=${state.filter.date.finish_to}` : ''}`
    const filter = `${state.filter.assignee.id !== 0 ? `search[assign_id]=${state.filter.assignee.id}` : ''}&${state.filter.column.id !== 0 ? `search[column]=${state.filter.column.id}` : ''}`
    const searchFilter = state.searchValue ? `search[any]=${state.searchValue}` : ''
    const expands = 'expand=assignees,watchers,owner,column'

    /* commit('SET_TASK_LIST_IS_LOADING') */
    axios.get(`${url}/tasks?sort=-id&per-page=${currentTake}&page=${currentPage}&${expands}&${filter}&${combinedFilter}&${dateFilter}&${searchFilter}`, config).then(response => {
      commit('GET_TASKS', response.data.data)
      commit('SET_TASK_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка задач', error)
    })
  },
  getTaskColumns ({ commit }) {
    const expands = 'expand=tasks'

    axios.get(`${url}/task-columns?sort-id&${expands}`, config).then(response => {
      commit('GET_TASK_COLUMNS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения колонок задач', error)
    })
  },
  toggleTaskListTableItemControls ({ commit }, itemId) {
    commit('TOGGLE_TASK_LIST_TABLE_ITEM_CONTROLS', itemId)
  },
  toggleTaskListTableItemChildren ({ commit }, itemId) {
    commit('TOGGLE_TASK_LIST_TABLE_ITEM_CHILDREN', itemId)
  },
  removeTask ({ commit }, taskId) {
    axios.delete(`${url}/tasks/${taskId}`, config).then(response => {
      this.dispatch('getTasks')
    }).catch(error => {
      console.log('ошибка удаления задачи', error)
    })
  },

  // create modal
  showTaskListCreateModal ({ commit }) {
    commit('SHOW_TASK_LIST_CREATE_MODAL')
  },
  closeTaskListCreateModal ({ commit }) {
    commit('CLOSE_TASK_LIST_CREATE_MODAL')
    commit('CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP')
    commit('CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP')
  },
  clearTaskListCreateModal ({ commit }) {
    commit('CLEAR_TASK_LIST_MODAL')
    commit('CLOSE_TASK_LIST_CREATE_MODAL')
    commit('CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP')
    commit('CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP')
  },
  clearTaskListModalValidation ({ commit }) {
    commit('CLEAR_TASK_LIST_MODAL_VALID')
  },
  setTaskListModalName ({ commit }, text) {
    commit('SET_TASK_LIST_NEW_TASK_NAME', text)
  },
  toggleTaskListModalImportance ({ commit }) {
    commit('TOGGLE_TASK_LIST_NEW_TASK_IMPORTANCE')
  },
  setTaskListModalDescription ({ commit }, text) {
    commit('SET_TASK_LIST_NEW_TASK_DESCRIPTION', text)
  },
  setTaskListModalDeadLine ({ commit }, date) {
    commit('SET_TASK_LIST_NEW_TASK_DEADLINE', date)
  },
  setTaskListModalParentTask ({ commit }, task) {
    commit('SET_TASK_LIST_NEW_TASK_PARENT_TASK', task)
  },
  setTaskListModalColumn ({ commit }, column) {
    commit('SET_TASK_LIST_NEW_TASK_COLUMN', column)
  },
  addTaskListModalAssignee ({ commit }, user) {
    commit('ADD_TASK_LIST_NEW_TASK_ASSIGNEE', user)
  },
  removeTaskListModalAssignee ({ commit }, user) {
    commit('REMOVE_TASK_LIST_NEW_TASK_ASSIGNEE', user)
  },
  addTaskListModalWatcher ({ commit }, user) {
    commit('ADD_TASK_LIST_NEW_TASK_WATCHER', user)
  },
  removeTaskListModalWatcher ({ commit }, user) {
    commit('REMOVE_TASK_LIST_NEW_TASK_WATCHER', user)
  },
  taskListModalToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_TASK_LIST_MODAL_LINK_TOOLTIP')
    commit('CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP')
  },
  taskListModalCloseLinkTooltip ({ commit }) {
    commit('CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP')
  },
  taskListModalSetLinkText ({ commit }, text) {
    commit('SET_TASK_LIST_MODAL_LINK_TEXT', text)
  },
  taskListModalSetLinkUrl ({ commit }, url) {
    commit('SET_TASK_LIST_MODAL_LINK_URL', url)
  },
  taskListModalToggleTagTooltip ({ commit }) {
    commit('TOGGLE_TASK_LIST_MODAL_TAG_TOOLTIP')
    commit('CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP')
  },
  taskListModalCloseTagTooltip ({ commit }) {
    commit('CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP')
  },
  taskListModalSetTagText ({ commit }, text) {
    commit('SET_TASK_LIST_MODAL_TAG_TEXT', text)
  },
  taskListModalAttachFiles ({ commit }, files) {
    commit('ATTACH_TASK_LIST_MODAL_FILES', files)
  },
  taskListModalRemoveFile ({ commit }, data) {
    commit('REMOVE_TASK_LIST_MODAL_FILE', data)
  },
  taskListModalAttachLink ({ commit, state }) {
    const text = state.createModal.attachment.linkTooltip.text
    const url = state.createModal.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_TASK_LIST_MODAL_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_TASK_LIST_MODAL_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_TASK_LIST_MODAL_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskListModalAttachTag ({ commit, state }) {
    if (state.createModal.attachment.tagTooltip.text) {
      commit('ATTACH_TASK_LIST_MODAL_TAG')
      commit('CLOSE_TASK_LIST_MODAL_TAG_TOOLTIP')
    } else {
      commit('SET_TASK_LIST_MODAL_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskListModalRemoveTag ({ commit }, index) {
    commit('REMOVE_TASK_LIST_MODAL_TAG', index)
  },
  taskListModalClearValidation ({ commit }) {
    commit('CLEAR_TASK_LIST_MODAL_VALID')
  },
  async taskListModalCreateTask ({ dispatch, commit, state }) {
    try {
      const data = {
        name: state.createModal.name,
        // валидация сервера пишет что значение поля is_important должно быть true/false на деле принимает только 0/1
        is_important: Number(state.createModal.is_important),
        description: clearUserHtml(state.createModal.description),
        before_at: state.createModal.date_deadline,
        // id колонки обязательно для заполнения
        column_id: state.createModal.column.id,
        // поле статус пока не используется, но оно обязательно при создании задачи
        status: 1,
        assignees: getValuesArray(state.createModal.assignees),
        watchers: getValuesArray(state.createModal.watchers),
        tags: state.createModal.attachment.tags
      }

      if (state.createModal?.parentTask?.id) {
        data.parent_id = state.createModal.parentTask.id
      }

      commit('[task-list-page] MODAL_REQUEST_START')

      const response = await createItem('tasks', data)
      const files = state.createModal.attachment.files

      if (files.length) {
        const formData = new FormData()
        files.forEach(file => formData.append('files[]', file))

        const taskId = response.data.data.id
        await createItem(`tasks/${taskId}/upload`, formData, configMultipart)
      }

      dispatch('[task-list-page] modalRequestSuccess')
    } catch (e) {
      commit('[task-list-page] MODAL_REQUEST_FAILURE')
      console.log('ошибка создания задачи', e.response)
      commit('SET_TASK_LIST_CREATE_MODAL_VALIDATION', e.response.data.validation)
    }
  },
  '[task-list-page] modalRequestSuccess' ({ dispatch, commit }) {
    commit('[task-list-page] MODAL_REQUEST_SUCCESS')
    commit('CLEAR_TASK_LIST_MODAL')
    commit('CLOSE_TASK_LIST_CREATE_MODAL')
    commit('CLEAR_TASK_LIST_MODAL_VALID')

    dispatch('getTasks')
  },

  // task-board
  toggleTaskBoardColorPicker ({ commit }) {
    commit('TOGGLE_TASK_BOARD_COLOR_PICKER')
  },
  setTaskBoardNewColumnColor ({ commit }, colorName) {
    commit('SET_TASK_BOARD_NEW_COLUMN_COLOR', colorName)
    commit('CLOSE_TASK_BOARD_COLOR_PICKER')
  },
  setTaskBoardNewColumnTitle ({ commit }, title) {
    commit('SET_TASK_BOARD_NEW_COLUMN_TITLE', title)
  },
  taskBoardCreateNewColumn ({ commit }) {
    console.log('ошибка создания новой колонки на доске задач')
  },
  showTaskBoardNewColumnForm ({ commit }) {
    commit('SHOW_TASK_BOARD_NEW_COLUMN_FORM')
  },
  closeTaskBoardNewColumnForm ({ commit }) {
    commit('CLOSE_TASK_BOARD_NEW_COLUMN_FORM')
  },
  toggleTaskBoardColumnControls ({ commit }, columnId) {
    commit('TOGGLE_TASK_BOARD_COLUMN_CONTROLS', columnId)
  },
  closeTaskBoardColumnControls ({ commit }) {
    commit('CLOSE_TASK_BOARD_COLUMN_CONTROLS')
  },
  setTaskBoardColumnNewPosition ({ commit, state }, dropResult) {
    const removedIndex = dropResult.removedIndex
    const addedIndex = dropResult.addedIndex
    const columnsArr = state.taskBoard.columns
    const columnId = columnsArr[removedIndex].id
    // цвет нужно отправлять иначе валидация не пропускает
    const columnColor = columnsArr[removedIndex].color
    const newSortOrder = removedIndex > addedIndex ? columnsArr[addedIndex].sort_order - 1 : removedIndex < addedIndex ? columnsArr[addedIndex].sort_order + 1 : columnsArr[removedIndex].sort_order
    console.log('from', removedIndex)
    console.log('to', addedIndex)

    commit('SORT_TASK_BOARD_COLUMNS', dropResult)
    axios.put(`${url}/task-columns/${columnId}`, { sort_order: newSortOrder, color: columnColor }, config).then(response => {
      console.log('сортировка колонок выполнена успешно')
    }).catch(error => {
      this.dispatch('getTaskColumns')
      console.log('ошибка сортировки колонок', error.response)
    })
  },
  pickTaskBoardCard ({ commit }, data) {
    console.log('pick', data)
    commit('PICK_TASK_BOARD_CARD', data)
  },
  setTaskBoardCardNewPosition ({ commit, state }, data) {
    const removedIndex = data.dropResult.removedIndex
    const addedIndex = data.dropResult.addedIndex
    const pickedCard = state.taskBoard.pickedCard

    // перемещение внутри колонки
    if (addedIndex !== null && removedIndex !== null) {
      /* const columnId = data.columnId
      const cardArray = state.taskBoard.columns.find(column => column.id === columnId).tasks */
      const newSortOrder = pickedCard.sort_order /* removedIndex > addedIndex ? cardArray[addedIndex].sort_order - 1 : removedIndex < addedIndex ? cardArray[addedIndex].sort_order + 1 : pickedCard.sort_order */

      axios.put(`${url}/tasks/${pickedCard.id}`, { sort_order: newSortOrder }, config).then(response => {
        console.log('сортировка карточек задач выполнена успешно')
      }).catch(error => {
        this.dispatch('getTaskColumns')
        console.log('ошибка сортировки карточек задач', error.response)
      })
    }

    // перемещение карточек между колонок
    if (addedIndex !== null && removedIndex === null) {
      const columnId = data.columnId
      const cardArray = state.taskBoard.columns.find(column => column.id === columnId).tasks
      const newSortOrder = cardArray[addedIndex] !== undefined ? cardArray[addedIndex].sort_order - 1 : cardArray[addedIndex - 1].sort_order + 1

      axios.put(`${url}/tasks/${pickedCard.id}`, { sort_order: newSortOrder, column_id: columnId }, config).then(response => {
        console.log('сортировка карточек задач выполнена успешно')
      }).catch(error => {
        this.dispatch('getTaskColumns')
        console.log('ошибка сортировки карточек задач', error.response)
      })
    }

    commit('DROP_TASK_BOARD_CARD', data)
  },

  // pagination
  toggleTaskListPageList ({ commit }) {
    commit('TOGGLE_TASK_LIST_PAGE_LIST')
  },
  getTaskListPrevPage ({ state, commit }) {
    const combinedFilter = state.filter.list.data
    const dateFilter = `${state.filter.date.created_from ? `search[created_from]=${state.filter.date.created_from}` : ''}&${state.filter.date.created_to ? `search[created_to]=${state.filter.date.created_to}` : ''}&${state.filter.date.finish_from ? `search[before_from]=${state.filter.date.finish_from}` : ''}&${state.filter.date.finish_to ? `search[before_to]=${state.filter.date.finish_to}` : ''}`
    const filter = `${state.filter.assignee.id !== 0 ? `search[assign_id]=${state.filter.assignee.id}` : ''} ${state.filter.column.id !== 0 ? `search[column]=${state.filter.column.id}` : ''}`
    const searchFilter = state.searchValue ? `search[any]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const expands = 'expand=assignees,watchers,owner,column'

    axios.get(`${url}/tasks?&${searchFilter}&sort=-id&per-page=${currentTake}&page=${currentPage - 1}&${expands}&${filter}&${combinedFilter}&${dateFilter}`, config).then(response => {
      commit('GET_TASKS', response.data.data)
      commit('SET_TASK_LIST_PAGINATION', response.headers)
      commit('CLOSE_TASK_LIST_PAGE_LIST')
    })
  },
  getTaskListNextPage ({ state, commit }) {
    const combinedFilter = state.filter.list.data
    const dateFilter = `${state.filter.date.created_from ? `search[created_from]=${state.filter.date.created_from}` : ''}&${state.filter.date.created_to ? `search[created_to]=${state.filter.date.created_to}` : ''}&${state.filter.date.finish_from ? `search[before_from]=${state.filter.date.finish_from}` : ''}&${state.filter.date.finish_to ? `search[before_to]=${state.filter.date.finish_to}` : ''}`
    const filter = `${state.filter.assignee.id !== 0 ? `search[assign_id]=${state.filter.assignee.id}` : ''} ${state.filter.column.id !== 0 ? `search[column]=${state.filter.column.id}` : ''}`
    const searchFilter = state.searchValue ? `search[any]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    const expands = 'expand=assignees,watchers,owner,column'

    axios.get(`${url}/tasks?&${searchFilter}&sort=-id&per-page=${currentTake}&page=${currentPage + 1}&${expands}&${filter}&${combinedFilter}&${dateFilter}`, config).then(response => {
      commit('GET_TASKS', response.data.data)
      commit('SET_TASK_LIST_PAGINATION', response.headers)
      commit('CLOSE_TASK_LIST_PAGE_LIST')
    })
  },
  getTaskListPage ({ state, commit }, pageNum) {
    const combinedFilter = state.filter.list.data
    const dateFilter = `${state.filter.date.created_from ? `search[created_from]=${state.filter.date.created_from}` : ''}&${state.filter.date.created_to ? `search[created_to]=${state.filter.date.created_to}` : ''}&${state.filter.date.finish_from ? `search[before_from]=${state.filter.date.finish_from}` : ''}&${state.filter.date.finish_to ? `search[before_to]=${state.filter.date.finish_to}` : ''}`
    const filter = `${state.filter.assignee.id !== 0 ? `search[assign_id]=${state.filter.assignee.id}` : ''} ${state.filter.column.id !== 0 ? `search[column]=${state.filter.column.id}` : ''}`
    const searchFilter = state.searchValue ? `search[any]=${state.searchValue}` : ''
    const currentTake = state.pagination.currentTake
    const expands = 'expand=assignees,watchers,owner,column'

    axios.get(`${url}/tasks?&${searchFilter}&sort=-id&per-page=${currentTake}&page=${pageNum}&${expands}&${filter}&${combinedFilter}&${dateFilter}`, config).then(response => {
      commit('GET_TASKS', response.data.data)
      commit('SET_TASK_LIST_PAGINATION', response.headers)
    })
  },
  resetTaskListCurrentPage ({ commit }) {
    commit('RESET_TASK_LIST_CURRENT_PAGE')
  },

  // search
  setTasksSearchValue ({ commit }, searchValue) {
    commit('SET_TASK_LIST_SEARCH_VALUE', searchValue)
    this.dispatch('getTasks')
  },

  // filter
  toggleTaskListFilterDateCreated ({ commit }) {
    commit('TOGGLE_TASK_LIST_FILTER_DATE_CREATED')
    commit('CLOSE_TASK_LIST_FILTER_DATE_FINISH')
    commit('CLOSE_TASK_LIST_FILTER_LIST')
  },
  setTaskListFilterDateCreatedFrom ({ commit }, date) {
    commit('SET_TASK_LIST_FILTER_DATE_CREATED_FROM', date)
  },
  setTaskListFilterDateCreatedTo ({ commit }, date) {
    commit('SET_TASK_LIST_FILTER_DATE_CREATED_TO', date)
  },
  clearTaskListDateCreated ({ commit }) {
    commit('CLEAR_TASK_LIST_FILTER_DATE_CREATED')
    this.dispatch('getTasks')
  },
  toggleTaskListFilterDateFinish ({ commit }) {
    commit('TOGGLE_TASK_LIST_FILTER_DATE_FINISH')
    commit('CLOSE_TASK_LIST_FILTER_DATE_CREATED')
    commit('CLOSE_TASK_LIST_FILTER_LIST')
  },
  setTaskListFilterDateFinishFrom ({ commit }, date) {
    commit('SET_TASK_LIST_FILTER_DATE_FINISH_FROM', date)
  },
  setTaskListFilterDateFinishTo ({ commit }, date) {
    commit('SET_TASK_LIST_FILTER_DATE_FINISH_TO', date)
  },
  applyTaskListFilterDate ({ commit }) {
    this.dispatch('getTasks')
    commit('CLOSE_TASK_LIST_FILTER_DATE_CREATED')
    commit('CLOSE_TASK_LIST_FILTER_DATE_FINISH')
  },
  clearTaskListDateFinish ({ commit }) {
    commit('CLEAR_TASK_LIST_FILTER_DATE_FINISH')
    this.dispatch('getTasks')
  },
  toggleTaskListFilterList ({ commit }) {
    commit('TOGGLE_TASK_LIST_FILTER_LIST')
    commit('CLOSE_TASK_LIST_FILTER_DATE_CREATED')
    commit('CLOSE_TASK_LIST_FILTER_DATE_FINISH')
  },
  clearTaskListFilter ({ commit }) {
    commit('CLEAR_TASK_LIST_FILTER')
    commit('TOGGLE_TASK_LIST_FILTER_LIST')
    this.dispatch('getTasks')
  },
  setTaskListFilter ({ commit, rootState }, filter) {
    const filterData = {
      filter: filter,
      currentUserId: rootState.appData.currentUser.id
    }
    commit('SET_TASK_LIST_FILTER', filterData)
    commit('TOGGLE_TASK_LIST_FILTER_LIST')
    this.dispatch('getTasks')
  },
  setTaskListFilterColumn ({ commit }, column) {
    commit('SET_TASK_LIST_FILTER_COLUMN', column)
    this.dispatch('getTasks')
  },
  setTaskListFilterAssignee ({ commit }, user) {
    commit('SET_TASK_LIST_FILTER_ASSIGNEE', user)
    this.dispatch('getTasks')
  },

  // view switcher
  setTaskListListView ({ commit }) {
    commit('SET_TASK_LIST_LIST_VIEW')
  },
  setTaskListBoardView ({ commit }) {
    commit('SET_TASK_LIST_BOARD_VIEW')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
